import { createSlice } from "@reduxjs/toolkit";
import { getInitialDataApi } from "../configureStore";
export const initialDataSlice = createSlice({
    name: 'initialData',
    initialState:{},
    extraReducers:(builder) => {
        builder.addMatcher(getInitialDataApi.endpoints.fetchInitialData.matchFulfilled, (state, action) => {
            return action.payload
        })
    }

}
)
